import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import {UserEmailLogsCriteria} from '../typedef';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const userEmailDeliveryLogStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    UserEmailLogsCriteria
>('userEntitlementsChangeLogState', undefined);

export const userEmailDeliveryLogStateActions = userEmailDeliveryLogStateSlice.actions;
export const userEmailDeliveryLogStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    UserEmailLogsCriteria
> = state => state.userPage.tabs.loginAndPassword.state;
